import { useState, useEffect } from 'react';
import loginUser from "./../../js/utils/async/loginUser";

/*
  Хук. Проверяет авторизацию пользователя. 
  Отправляет запрос с данными для авторизации пользователя на сервер, для проверки авторизации.
  Если даннных для авторизации пользователя нет, либо сервер вернул отрицательный ответ, 
  то статус авторизации устанавливается false
  Если сервер вернул положительный ответ, то статус авторизации устанавливается true
  Параметры:
     credentials - данные для авторизации пользователя
  Вовращаемые параметры:
    Объект - {
      isLoaded:Boolean // статус запроса авторизации
      isLogged:Boolean // статус авторизации
    } 

*/
export default function useLogin(credentials){
  const [isLoaded, setIsLoaded] = useState(false)
  const [isLogged, setIsLogged] = useState()

  useEffect(() => {
    async function checkCredentials() {
      if (credentials) {
        const result = await loginUser(credentials);
        if (result.ok) {
          setIsLogged(true)
        } else setIsLogged(false)
        setIsLoaded(true)
      } else {
        setIsLoaded(true)
        setIsLogged(false)
      }
    }
    checkCredentials()
  })

  return {
    isLoaded,
    isLogged
  }
}